<template>
  <div class="master-container">
    <bimContainer>
      <bimCol cols=12 md=10 class="d-flex align-center mx-auto block-head__info">
        <div class="block-specifications">
          <bim-text class="block-specifications__title pb-9" type="h4" bold>{{ $t("Мастер спецификаций") }}</bim-text>
          <bim-text class="block-specifications__text" type="accent">{{ $t("Это удобный инструмент для подбора аналогов изделий. По параметрам, свойствам и наименованию.") }}</bim-text>
          
          <div class="w-100">
            <img
              class="block-specifications__image-scheme d-block mx-auto"
              src="/dist/assets/front_white/img/landing_plugin/scheme.png"
              alt=""
              srcset="
                /dist/assets/front_white/img/landing_plugin/scheme@2x.png 2x,
                /dist/assets/front_white/img/landing_plugin/scheme@3x.png 3x
              "
            />
          </div>

          <div class="advantages">
            <bim-text
              v-for="advantage of advantages"
              :key="advantage"
              type=medium
              bold
              class="advantages__text"
            >
              {{ advantage }}
            </bim-text>
          </div>

          <div class="how-it-works mb-11">
            <BimSteps
              :title="$t('Как это работает?')"
              :slides="slides"
            />
          </div>

          <div class="how-it-works__info info-block d-flex flex-column flex-lg-row">
            <div class="info-block__item">
              <bim-text type="accent" bold class="info-block__item-text">{{ $t("Посмотрите видео о том, как профессионалы работают с нашим плагином") }}</bim-text>
              <div class="info-block__link" @click="$emit('openVideoPopup')">
                <img src="/dist/assets/front_white/img/svg/play.svg" alt="" />
                <span class="info-block__link-text">{{ $t("Посмотреть видео") }}</span>
              </div>
            </div>
            <div class="info-block__item">
              <bim-text type="accent" bold class="info-block__item-text">{{ $t("Прочувствуйте современный формат работы со спецификациями сейчас") }}</bim-text>
              <div class="d-flex align-center">
                <ButtonPluginDownload />
                <img class="ml-9 d-none d-sm-block" width=26 src="/dist/assets/front_white/img/landing_plugin/icon-emoji-hand-left-26@3x.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
import bimButton from "@bimlib/components/bimButton"
import ButtonPluginDownload from "./ButtonPluginDownload"
import BimSteps from "@/components/BimSteps"
export default {
  name: "",
  components: {
    bimContainer,
    bimCol,
    bimButton,

    ButtonPluginDownload,
    BimSteps
  },

  data() {
    return {
      advantages: [
        "Актуальная база продукции;",
        "Быстрый подбор по свойствам, параметрам, наименованию;",
        "Сравнение до трех позиций продукции между друг другом;",
        "Выгрузка документации со штампами 5 и 6;",
        "Сопряжение с САПР-системами;",
      ],
      slides: [
        {
          title: this.$t("Создаете проект."),
          desc: this.$t("Наполняете его спецификациями из нашей базы или любыми семействами."),
          img: "/dist/assets/front_white/img/landing_plugin/2020-12-17_17-41-09.png"
        },
        {
          title: this.$t("Создаёте спецификацию."),
          desc: this.$t("Выберите ту категорию изделий, в которой требуется подбор или замена."),
          img: "/dist/assets/front_white/img/landing_plugin/2020-12-21_15-29-28.png"
        },
        {
          title: this.$t("Запускаете Мастер спецификаций и получаете выгрузку с продуктами — аналогами."),
          desc: this.$t("Плагин найдет аналоги, а результаты подбора можно выгрузить в привычном формате."),
          img: "/dist/assets/front_white/img/landing_plugin/2020-12-21_16-10-39.png"
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/grid-settings";
@import "./src/front_white/sass/components/color";

.master-container {
  width: 100%;
  background-color: $white-color;
}

.block-specifications {
  padding: 64px 0;

  .block-specifications__title,
  .block-specifications__text {
    text-align: center;
  }

  .block-specifications__title {
    line-height: 1.14;
    width: 100%;

    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 22px;
      }
    }
  }
  
  .block-specifications__text {
    line-height: 1.42;
    width: 65%;
    margin: auto;
    
    @media screen and (max-width: $breakpoint-sm) {
      width: 100%;
      font-size: 14px;
    }
  }

  .block-specifications__image-scheme {
    padding: 70px 0;
  }

  .advantages {
    border-top: 1px solid $white-color-500;
    padding: 24px 0 42px;
    display: flex;

    @media screen and (max-width: $breakpoint-md) {
      flex-wrap: wrap;
    }

    .advantages__text {
      color: $primary-color;
      margin-right: 32px;
      flex: 1 1 20%;
      
      &:last-child {
        margin-right: 0px;
      }

      @media screen and (max-width: $breakpoint-md) {
        margin-bottom: 32px;
        flex: 0 1 47%;

        &:nth-child(even) {
          margin-right: 0;
        }
      }

      @media screen and (max-width: $breakpoint-sm) {
        margin-right: 0;
        flex: 0 0 100%;
      }
    }
  }
}

.info-block {
  display: flex;
  justify-content: center;
  
  .info-block__item {
    max-width: 565px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    padding: 32px;
    border-radius: 15px;
    border: solid 1.5px #e0e0e0;
    flex: 0 0 50%;

    @media screen and (max-width: $breakpoint-sm) {
      padding: 24px;
    }

    .info-block__item-text {
      padding-bottom: 26px;

      @media screen and (max-width: $breakpoint-sm) {
        font-size: 14px;
      }
    }

    &:nth-child(odd) {
      margin-right: 30px;

      @media screen and (max-width: $breakpoint-lg) {
        margin-right: 0;
        margin-bottom: 30px;
      }
    }
  }

  .info-block__link {
    display: flex;
    align-items: center;
    cursor: pointer;

    font-size: 18px;
    font-weight: bold;
    color: $primary-color;

    @media screen and (max-width: 575px) {
      font-size: 16px;
    }

    &:hover {
      opacity: 0.7;
    }

    .info-block__link-text {
      padding-left: 8px;
    }
  }
}

.how-it-works {
  .how-it-works__title {
    line-height: 1.13;
  }
}
</style>
